import React from 'react';
import clone from 'clone';
import classNames from 'classnames';

class ColorBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChecked = this.handleChecked.bind(this);
  }
  handleChecked(item) {
    const values = [];
    this.options.forEach((singleitem) => {
      if (singleitem.key === parseInt(item.key, 10)) {
        singleitem.isChecked = !singleitem.isChecked;
      }
      if (singleitem.isChecked) values.push(singleitem);
    });
    this.props.onSelectColorBox(values);
  }
  render() {
    this.options = clone(this.props.options);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
      }
    });
    const CustomClassName = classNames({
      'single-input big-box': this.props.type === 'big',
      'single-input rq-name-of-product-color': this.props.showItemColorName === 'true',
      'single-input': this.props.showItemColorName !== 'true',
    });

    const singleColorBoxItem = (item, index) => {
      const CustomClassNameHover = classNames({
        'hover-effect': this.props.type === 'hover',
        'color-white': this.props.type !== 'hover' && item.value === '#FFFFFF',
      });
      const CustomStyle = {
        backgroundColor: item.value,
      };
      return (
          <span className={CustomClassName + ' ' + ' ' + 'colorbox'} key= {index}>
            <input type = "checkbox" checked={item.isChecked} id={'color-box-' + item.slug + '-' + this.props.block.uid} value={item.key} onChange = {this.handleChecked.bind(this, item)}/>
            <label style = {CustomStyle} className={CustomClassNameHover} htmlFor= {'color-box-' + item.slug + '-' + this.props.block.uid}>
            </label>
            {this.props.showItemColorName === 'true' ?
              <span className="rq-color-of-product">
                { item.value }
              </span>
            : ''}
          </span>
          );
    };
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    let setColumnStyle = null;
    if (this.props.setColumn === '1') {
      setColumnStyle = 'checkbox-input-content';
    } else if (this.props.setColumn === '2') {
      setColumnStyle = 'checkbox-input-content split';
    } else if (this.props.setColumn === '3') {
      setColumnStyle = 'checkbox-input-content split-2';
    } else if (this.props.setColumn === '4') {
      setColumnStyle = 'checkbox-input-content split-3';
    }
    return (
      <div className={childInputClass}>
        <span className={setColumnStyle}>
          {this.options.length ? this.options.map(singleColorBoxItem) : null}
        </span>
      </div>
    );
  }
}
ColorBox.propTypes = {
  'type': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectColorBox': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
  'showItemColorName': React.PropTypes.string,
  'setColumn': React.PropTypes.string,
  'block': React.PropTypes.object,
};

export default ColorBox;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/colorbox.js
 **/